<div
  class="fixed inset-y-0 left-0 bg-[var(--color-brand-400)] dark:bg-[var(--color-dark-bg-primary)] border-r border-[var(--color-gray-200)] dark:border-[var(--color-gray-700)] flex flex-col z-[200] transition-all duration-100"
  [ngClass]="{
    'w-14 items-center space-y-2': !isMenuExpanded && !isMobile,
    'w-64': isMenuExpanded,
    'w-0 overflow-hidden': isMobile && !isMenuExpanded
  }">
  
  <!-- Menú expandido -->
  @if (isMenuExpanded) {
    <div class="flex items-center justify-between pl-6 pr-4 pt-7 pb-4">
      <div class="flex items-center">
        <a href="/" (click)="$event.preventDefault(); openHome()">
          <img src="assets/images/Ardia-Logo.svg" alt="ARDIA" class="h-7 w-auto cursor-pointer">
        </a>
      </div>
      <button (click)="toggleMenuExpanded()"
        class="w-5 h-5 flex items-center justify-center rounded cursor-pointer hover:bg-[var(--color-brand-100)] dark:hover:bg-[var(--color-white)]/10 p-3 group">
        <fa-icon [icon]="faChevronLeft"
          class="text-base text-[var(--color-text-100)] dark:text-[var(--color-text-100)] group-hover:text-[var(--color-text-300)]"></fa-icon>
      </button>
    </div>

    <div class="flex flex-col h-full px-2 space-y-1 mt-8">
      <app-sidebar-navigation-group
        [group]="primaryNavGroup"
        variant="backoffice-expanded"
        [currentSection]="activeMenuSection"
        [separatorClass]="''"
        [titleClass]="''"
        [itemsClass]="'space-y-1'"
        (itemSelected)="onNavigationItemClick($any($event))"
      ></app-sidebar-navigation-group>

      <div class="flex-1"></div>
      <app-sidebar-navigation-group
        [group]="secondaryNavGroup"
        variant="backoffice-expanded"
        [currentSection]="activeMenuSection"
        [separatorClass]="''"
        [titleClass]="''"
        [itemsClass]="'space-y-2'"
        [itemWrapperClass]="'mb-2'"
        (itemSelected)="onNavigationItemClick($any($event))"
      ></app-sidebar-navigation-group>
    </div>
  } @else if (!isMobile) {
    <!-- Menú colapsado -->
    <div class="pt-5 flex items-center justify-center mb-2">
       <a href="/" (click)="$event.preventDefault(); openHome()">
           <img src="assets/images/Ardia-Logo-Colapsado.svg" alt="ARDIA" class="h-10 w-auto cursor-pointer">
        </a>
    </div>

    <div class="flex flex-col h-full space-y-1">
      <button (click)="toggleMenuExpanded()"
        class="w-5 h-5 flex items-center justify-center rounded cursor-pointer hover:bg-[var(--color-brand-100)] dark:hover:bg-[var(--color-white)]/10 p-3 group mx-auto mt-1 mb-2"
        title="Expandir menú">
        <fa-icon [icon]="faChevronRight"
          class="text-base text-[var(--color-text-100)] dark:text-[var(--color-text-100)] group-hover:text-[var(--color-text-300)]"></fa-icon>
      </button>

      <app-sidebar-navigation-group
        [group]="primaryNavGroup"
        variant="backoffice-collapsed"
        [currentSection]="activeMenuSection"
        [separatorClass]="''"
        [titleClass]="''"
        [itemsClass]="'space-y-1'"
        (itemSelected)="onNavigationItemClick($any($event))"
      ></app-sidebar-navigation-group>

      <div class="flex-1"></div>
      <app-sidebar-navigation-group
        [group]="secondaryNavGroup"
        variant="backoffice-collapsed"
        [currentSection]="activeMenuSection"
        [separatorClass]="''"
        [titleClass]="''"
        [itemsClass]="'space-y-2'"
        [itemWrapperClass]="'mb-2'"
        (itemSelected)="onNavigationItemClick($any($event))"
      ></app-sidebar-navigation-group>
    </div>
  }
</div>
